namespace $ {

	export function $shm_agent_token() {
		const context = $mol_dom_context
		const query = new URL( context.location.href ).searchParams.get( 'token' )?.trim()
		if( query ) return query
		try {
			const stored = context.localStorage.getItem( 'hitalama_agent_token' )
			if( !stored ) return ''
			try { return String( JSON.parse( stored ) ?? '' ).trim() }
			catch { return stored.trim() }
		} catch {
			return ''
		}
	}

}
